/* The product's pictures beside the facts panel (snippets/product-gallery.liquid): one at a time,
 * arrows, thumbs, the keyboard and a swipe — the same grammar as the ingredient carousel
 * (assets/product-ingredients.js), on a simpler box. The HTML is a list with the first picture
 * marked active; this adds one class, un-hides the arrows and the thumbs, and moves the index.
 * The end wraps.
 */
(() => {
  document.querySelectorAll('.pp-gal').forEach((box) => {
    const items = [...box.querySelectorAll('.pp-gal__slide')];
    const n = items.length;
    if (!n) return;
    box.classList.add('is-js');
    if (n < 2) return;

    const thumbs = [...box.querySelectorAll('[data-gal="go"]')];
    box.querySelectorAll('[data-gal], .pp-gal__thumbs').forEach((el) => { el.hidden = false; });

    let i = Math.max(0, items.findIndex((el) => el.classList.contains('is-active')));

    /* Keep the active thumb in view by scrolling THE THUMB RAIL, and never the page.
     *
     * This was `b.scrollIntoView({ block: 'nearest', inline: 'nearest' })` (Dayton, 2026-09-23:
     * "when I land on a product page, the page loads scrolled down to the h1 and the hero image and
     * hero card where you add the product are above the fold"). scrollIntoView scrolls whichever
     * ancestor can scroll, and the default thumb rail is `flex-wrap: wrap` — it never scrolls — so
     * the browser walked up to the DOCUMENT and pulled the whole page down to the gallery. `go(i)`
     * runs once on load to mark the first thumb, so every product with two or more pictures opened
     * below its own hero and its Add to Cart.
     *
     * Only `.pp-gal--right` — the 760px-and-up column — actually scrolls, so the overflow tests
     * below are false in the common case and this does nothing at all. Setting scrollTop/scrollLeft
     * on the rail cannot move the page, which is the property that matters.
     */
    function reveal(b) {
      const rail = b.closest('.pp-gal__thumbs');
      if (!rail) return;
      const r = rail.getBoundingClientRect();
      const t = b.getBoundingClientRect();
      if (rail.scrollHeight > rail.clientHeight) {
        if (t.top < r.top) rail.scrollTop -= r.top - t.top;
        else if (t.bottom > r.bottom) rail.scrollTop += t.bottom - r.bottom;
      }
      if (rail.scrollWidth > rail.clientWidth) {
        if (t.left < r.left) rail.scrollLeft -= r.left - t.left;
        else if (t.right > r.right) rail.scrollLeft += t.right - r.right;
      }
    }

    function go(to) {
      i = ((to % n) + n) % n;
      items.forEach((el, k) => el.classList.toggle('is-active', k === i));
      thumbs.forEach((b) => {
        const on = Number(b.dataset.i) === i;
        b.setAttribute('aria-current', String(on));
        if (on) reveal(b);
      });
    }

    box.addEventListener('click', (e) => {
      const b = e.target.closest('[data-gal]');
      if (!b || !box.contains(b)) return;
      if (b.dataset.gal === 'prev') go(i - 1);
      else if (b.dataset.gal === 'next') go(i + 1);
      else if (b.dataset.gal === 'go') go(Number(b.dataset.i) || 0);
    });

    box.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(i - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); go(i + 1); }
    });

    const stage = box.querySelector('.pp-gal__stage');
    let x0 = null;
    stage.addEventListener('pointerdown', (e) => { if (e.pointerType !== 'mouse') x0 = e.clientX; });
    stage.addEventListener('pointerup', (e) => {
      if (x0 === null) return;
      const dx = e.clientX - x0;
      x0 = null;
      if (Math.abs(dx) >= 40) go(dx < 0 ? i + 1 : i - 1);
    });
    stage.addEventListener('pointercancel', () => { x0 = null; });

    go(i);
  });
})();
